<template>
	<div class="modal-popup bg-content">
		<div class="modal-close text-primary" @click="onClose">
			&times;
		</div>
		<div class="modal-content">
			<div>
				<h2 class="text-primary font-uppercase">
					{{ $tc('modals.addTeam.title') }}
				</h2>
				<h3 class="mt-50 text-black font-uppercase">
					{{ $tc('modals.addTeam.subtitle') }}
				</h3>
				<p class="mt-25 text-black font-regular">
					{{ $tc('modals.addTeam.mainText') }}
				</p>
			</div>
			<div class="mt-50">
				<add-team-form :teams="options.teams" @success="onConfirm" />
			</div>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'
import AddTeamForm from '~/components/forms/AddTeamForm'

export default {
	name: 'ModalAddTeam',
	components: { AddTeamForm },
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>
